<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="512" height="512" fill="none">
  <style>.s{stroke:currentColor;stroke-width:12;stroke-linecap:round;stroke-linejoin:round}</style>
  <!-- Soft outer ring for empty state presence -->
  <circle cx="128" cy="128" r="92" stroke="currentColor" opacity="0.2" fill="none" stroke-width="12"/>
  <!-- Wi‑Fi arcs -->
  <path d="M64 120c36-36 92-36 128 0" class="s"/>
  <path d="M86 142c24-24 60-24 84 0" class="s"/>
  <path d="M110 164c10-10 26-10 36 0" class="s"/>
  <circle cx="128" cy="180" r="7" fill="currentColor"/>
  <!-- Slash -->
  <path d="M84 84l88 88" class="s"/>
</svg>
